// src/containers/Codes/titleStringsCodes.js

import CodeSet from './CodeSet';


const titleStringsCodes = new CodeSet('titleStrings', {
  fr: 'titres',
  it: 'titoli',
  es: 'títulos',
  de: 'titel',
  da: 'titler',
  nl: 'titels',
  no: 'titler',
  sv: 'titlar'
});

// Nain (0)
titleStringsCodes.addData(0, { en: 'Nain', fr: 'Nain', it: 'Nain', es: 'Nain', de: 'Nain', da: 'Nain', nl: 'Nain', no: 'Nain', sv: 'Nain' });

// Patchwork (1)
titleStringsCodes.addData(1, { en: 'Patchwork', fr: 'Patchwork', it: 'Patchwork', es: 'Patchwork', de: 'Patchwork', da: 'Patchwork', nl: 'Patchwork', no: 'Patchwork', sv: 'Patchwork' });

// Sumak (2)
titleStringsCodes.addData(2, { en: 'Sumak', fr: 'Sumak', it: 'Sumak', es: 'Sumak', de: 'Sumak', da: 'Sumak', nl: 'Sumak', no: 'Sumak', sv: 'Sumak' });

// Kilim (3)
titleStringsCodes.addData(3, { en: 'Kilim', fr: 'Kilim', it: 'Kilim', es: 'Kilim', de: 'Kilim', da: 'Kilim', nl: 'Kilim', no: 'Kilim', sv: 'Kilim' });

// Gabbeh (4)
titleStringsCodes.addData(4, { en: 'Gabbeh', fr: 'Gabbeh', it: 'Gabbeh', es: 'Gabbeh', de: 'Gabbeh', da: 'Gabbeh', nl: 'Gabbeh', no: 'Gabbeh', sv: 'Gabbeh' });

// Kids (5)
titleStringsCodes.addData(5, { en: 'Kids', fr: 'Enfants', it: 'Bambini', es: 'Niños', de: 'Kinder', da: 'Børn', nl: 'Kinderen', no: 'Barn', sv: 'Barn' });

// Tabriz (6)
titleStringsCodes.addData(6, { en: 'Tabriz', fr: 'Tabriz', it: 'Tabriz', es: 'Tabriz', de: 'Tabriz', da: 'Tabriz', nl: 'Tabriz', no: 'Tabriz', sv: 'Tabriz' });

// Vintage (7)
titleStringsCodes.addData(7, { en: 'Vintage', fr: 'Vintage', it: 'Vintage', es: 'Vintage', de: 'Vintage', da: 'Vintage', nl: 'Vintage', no: 'Vintage', sv: 'Vintage' });

// Turkoman (8)
titleStringsCodes.addData(8, { en: 'Turkoman', fr: 'Turkmène', it: 'Turcomanno', es: 'Turcomano', de: 'Turkmenisch', da: 'Turkmensk', nl: 'Turkmeens', no: 'Turkmensk', sv: 'Turkmensk' });

// Tibetan (9)
titleStringsCodes.addData(9, { en: 'Tibetan', fr: 'Tibétain', it: 'Tibetano', es: 'Tibetano', de: 'Tibetisch', da: 'Tibetansk', nl: 'Tibetaans', no: 'Tibetansk', sv: 'Tibetansk' });

// Prayer (10)
titleStringsCodes.addData(10, { en: 'Prayer', fr: 'Prière', it: 'Preghiera', es: 'Rezo', de: 'Gebet', da: 'Bøn', nl: 'Gebed', no: 'Bønn', sv: 'Bön' });

// Baluch (11)
titleStringsCodes.addData(11, { en: 'Baluch', fr: 'Baloutche', it: 'Baluch', es: 'Baluch', de: 'Baluch', da: 'Baluch', nl: 'Baluch', no: 'Baluch', sv: 'Baluch' });

// Hamadan (12)
titleStringsCodes.addData(12, { en: 'Hamadan', fr: 'Hamadan', it: 'Hamadan', es: 'Hamadan', de: 'Hamadan', da: 'Hamadan', nl: 'Hamadan', no: 'Hamadan', sv: 'Hamadan' });

// Kashan (13)
titleStringsCodes.addData(13, { en: 'Kashan', fr: 'Kashan', it: 'Kashan', es: 'Kashan', de: 'Kashan', da: 'Kashan', nl: 'Kashan', no: 'Kashan', sv: 'Kashan' });

// Bakhtiari (14)
titleStringsCodes.addData(14, { en: 'Bakhtiari', fr: 'Bakhtiari', it: 'Bakhtiari', es: 'Bakhtiari', de: 'Bakhtiari', da: 'Bakhtiari', nl: 'Bakhtiari', no: 'Bakhtiari', sv: 'Bakhtiari' });


export default titleStringsCodes;
